import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import DetailField from 'components/object/DetailField';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import momentDate from 'moment';
import 'moment/locale/fr';

const DesktopDatePickerCustom = (props) => {
  var canRead = 1;
  var canWrite = 1;
  var isRequired = false;

  if (props.controlFieldsStatus) {
    canRead = props.read;
    canWrite = props.write;
    isRequired = props.required;
  } else if (typeof props.required != "undefined") {
    isRequired = props.required;
  }

  var requiredStar = "";
  if (isRequired) requiredStar = " *";

  var widthPercent = '18%';
  if (props.fullWidth) widthPercent = '100%';

  var classError = "";
  if(props.error){
    classError = " Mui-error";
  }

  // Detect screen width to change date format
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getInputFormatFormParamViews = () => {
    var viewsFormat = [];
    if (props?.views) {
      if (props?.views.length > 0) {
        const day = props?.views.findIndex(arr => arr === 'day');
        if (day >= 0) viewsFormat.push('DD');
        const month = props?.views.findIndex(arr => arr === 'month');
        if (month >= 0) viewsFormat.push('MM');
        const year = props?.views.findIndex(arr => arr === 'year');
        if (year >= 0) viewsFormat.push('YYYY');
      }
    }
    const inputFormat = viewsFormat.join('/');
    return inputFormat;
  }

  const getDateFormat = () => {
    // Use DD/MM/YY for screens smaller than 1300px, otherwise DD/MM/YYYY
    return windowWidth < 1300 ? "DD/MM/YY" : "DD/MM/YYYY";
  }

  const callChange = (e) => {
    if (props?.changeParams) {
      props.onChange(e, props?.changeParams);
    } else {
      props.onChange(e);
    }
  }

  //auto open
  const [pickerOpen, setPickerOpen] = useState(false);
  const handlePickerClose = () => {
    setPickerOpen(false);
  };

  const handlePickerOpen = () => {
    setPickerOpen(true);
  };

  useEffect(() => {
    if (!!props?.autoOpen !== false) {
      handlePickerOpen();
    }
  }, [props?.autoOpen]);


  if (canWrite){
    return (
      <FormControl className={"textField-form-date"+classError} sx={{ m: 1, width: widthPercent, marginLeft: 1, marginRight: 1, marginTop: 0, marginBottom: 0 }} size="small" error={props.error} required={isRequired}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="fr">
          <DesktopDatePicker
            inputRef={props?.inputRef}
            label={!!props?.label ? props.label+requiredStar : ''}
            inputFormat={props?.views ? getInputFormatFormParamViews() : getDateFormat()}
            format= {getDateFormat()}
            value={props.value}
            views={props?.views ? props.views : null}
            onChange={callChange}
            renderInput={(params) => <TextField {...params} />}
            error={props.error} 

            open={pickerOpen}
            onClose={handlePickerClose}
            onOpen={handlePickerOpen}
          />
        </LocalizationProvider>
        {(props.error && (!!props.helperText != false)) && <FormHelperText sx={{ ml: 0}}>{props.helperText}</FormHelperText>}
      </FormControl>
    );
  }

  if (canRead){
    return <DetailField title={props.label} content={(props.value && props.value.length > 3) ? momentDate(props.value).format("DD MMM YY"):""} size={''} canRead={canRead} />
  }
}
export default DesktopDatePickerCustom
